import DividerIcon from 'images/divider_icon.gif';
import DividerIconHover from 'images/divider_icon_hover.gif';
import Side2PlaceHolder from 'images/side2_placeholder1.gif';
import Side2PlaceHolderHover from 'images/side2_placeholder1_hover.gif';

import LearnEditor from 'admin/editor/editor';
import PageManagement from 'admin/editor/components/page_management';

var learnEditor;

$(document).ready(function() {
  if ($('#page-management-sidebar').length) {
    new PageManagement();
  }

  if (!$('#page-editor').length) {
    // return as we're not in the editor
    return;
  }

  var ua = navigator.userAgent,
    action = (ua.match(/iPad/i)) ? "touchstart" : "click";
  //used as a global to store the unedited text, in case someone cancels in the editor.
  var activeElementId, activePosition;
  //used to save the add buttons, if they get removed
  var $saved_add_buttons;

  if (!$('.mirror').length) {
    learnEditor = new LearnEditor('#page-editor').init();

    // this will add the image modifiers to assets
    $(document).on('mouseenter', '#table-modal .table-image', function() {
      $('.build-image-options, .editor-table-build-image', this).css('visibility', 'visible');
    }).on('mouseleave', '#table-modal .table-image', function() {
      $('.build-image-options, .editor-table-build-image', this).css('visibility', 'hidden');
    });

    //changing hover image of gif
    $(document).on('mouseenter', '.enable-editor-buttons', function() {
      if (learnEditor.is_editor_enabled()) {
        return;
      }

      $(this).find('img').attr('src', DividerIconHover);
      $(this).siblings('.border-line').addClass('hover');

    }).on('mouseleave', '.enable-editor-buttons', function() {
      $(this).find('img').attr('src', DividerIcon);
      $(this).siblings('.border-line').removeClass('hover');
    });

    //clear text from embed, alert, faq input
    $(document).on(action, '.build-input', function(event) {
      if ($(this).val().indexOf('Enter ') != -1) {
        $(this).val('');
      }
    });

    $(document).on(action, '.build-side-wrapper a', function(event) {
      event.preventDefault();
    });
  }
});
